import { buttonModes, icons } from '@/utils'

import button from '@/components/button'

export default function(h) {
  return h(
    button,
    {
      props: {
        icon: icons.person_search,
        mode: buttonModes.flat,
        tooltip: this.getTranslate('commons.tooltips.filter.sendings')
      },
      on: {
        click: () => {
          this.filter()
        }
      }
    }
  )
}
